import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/menu/initialStates/combos_initialState.ts
var COMBO_ITEM_OF_ITEM_GROUP_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  locationMenuTypeComboGroupId: 0,
  itemId: 0,
  active: true,
  additionalPrice: 0,
  sortPriority: 0,
  isDisabled: false,
  override: {
    additionalPrice: false,
    active: false
  }
});
var COMBO_ITEM_GROUP_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  locationMenuTypeComboId: 0,
  required: false,
  active: true,
  sortPriority: 0,
  locationMenuTypeComboGroupId: 0,
  itemGroupId: 0,
  locationMenuTypeComboGroupVersionId: 0,
  items: {},
  posName: "",
  name: "",
  quantity: 1,
  override: {
    required: false
  }
});
var COMBO_MENU_TYPE_VERSION_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  menuTypeId: 0,
  locationId: 0,
  menuTypeComboId: 0,
  locationMenuTypeComboId: 0,
  locationMenuTypeComboVersionId: 0,
  specialTagId: null,
  posName: "",
  kdsName: "",
  checkName: "",
  description: "",
  imageUrl: null,
  secondaryImageUrl: null,
  onlineDescription: "",
  backgroundColor: null,
  textColor: null,
  kdsColor: null,
  allowSharing: true,
  active: true,
  activeOnline: true,
  delivery: false,
  onlinePrice: 0,
  deliveryPrice: 0,
  comboBasePrice: 0,
  taxInclusive: false,
  excludeFromSuggestedTip: false,
  excludeFromDiscounts: false,
  removeFromCheck: false,
  onlineName: "",
  itemGroups: {},
  sortPriority: 0,
  specials: {},
  defaultNoSeat: false,
  displayPictureOnCard: false,
  volume: 0,
  unit: "ml" /* ML */,
  taxIds: [],
  inheritedTaxes: {
    menuTypeInheritedTaxes: {},
    categoryInheritedTaxes: {},
    subcategoryInheritedTaxes: {}
  },
  toGoPrice: 0,
  spacesBefore: 0,
  categoriesSubcategories: {},
  displayComboPriceOnRegister: true,
  hideComboName: false,
  transparentBackground: false,
  doneIsForTable: false
});
var COMBO_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  organizationId: 0,
  createdByLocationId: 0,
  name: "",
  comboId: 0,
  menuTypeVersions: {
    "0": COMBO_MENU_TYPE_VERSION_INITIAL_STATE
  },
  locationIds: [],
  reportingGroupIds: []
});
var COMBO_INITIAL_STATE_FOR_SAVING = __spreadProps(__spreadValues({}, COMBO_INITIAL_STATE), {
  menuTypeVersions: {}
});

export { COMBO_INITIAL_STATE, COMBO_INITIAL_STATE_FOR_SAVING, COMBO_ITEM_GROUP_INITIAL_STATE, COMBO_ITEM_OF_ITEM_GROUP_INITIAL_STATE, COMBO_MENU_TYPE_VERSION_INITIAL_STATE };
